<template>
    <div class="container text-center my-4">
      <h2>Facebook Authorization</h2>
      <input v-model="email" type="email" class="form-control my-3" placeholder="Email" />
      <button class="btn btn-primary" @click="handleAuthorization">Autorizar</button>
      <p v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</p>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        email: '',
        errorMessage: '',
      };
    },
    methods: {
      handleAuthorization() {
        if (this.email === 'postlogin@fb.test') {
          this.$router.push('/age-terms-fb');
        } else if (this.email === 'bethere@fb.test') {
          this.$router.push('/welcome-back');
        } else {
          this.$router.push({ path: '/facebook-register', query: { email: this.email } });
        }
      },
    },
  };
  </script>
  